import { render, staticRenderFns } from "./SidebarTypePartner.vue?vue&type=template&id=3e766922&scoped=true"
import script from "./SidebarTypePartner.vue?vue&type=script&lang=js"
export * from "./SidebarTypePartner.vue?vue&type=script&lang=js"
import style0 from "./SidebarTypePartner.vue?vue&type=style&index=0&id=3e766922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e766922",
  null
  
)

export default component.exports